import { addDisplayName, flowMax } from 'ad-hok'
import { FC } from 'react'
import { CreatorLaunchImageInput } from 'shared/src/api/types'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { FormProps } from './resource'
import { ImageField } from './ImageField'

export const CreatorLaunchImageForm: FC<
  FormProps<Partial<CreatorLaunchImageInput>>
> = flowMax(
  addDisplayName('CreatorLaunchImageForm'),
  addTranslationHelpers,
  ({ values, onChange, errors, t }) => (
    <div>
      <ImageField
        id="imageId"
        label={t('admin.resources.creatorLaunchImages.fields.imageId')}
        value={values.imageId}
        onChange={(imageId) => {
          onChange({ ...values, imageId })
        }}
        error={errors.imageId}
      />
    </div>
  )
)
